(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zd-booking-intake"] && !Shopify.designMode) return;
  try {
    const intake=document.getElementById('ZonlidoogBookingIntake');
if(intake){const minimum=intake.querySelector('#zd-booking-budget-min');const maximum=intake.querySelector('#zd-booking-budget-max');if(minimum&&maximum){const checkRange=()=>{maximum.setCustomValidity('');if(minimum.value!==''&&maximum.value!==''&&Number(maximum.value)<Number(minimum.value)){maximum.setCustomValidity(maximum.dataset.rangeError);}};minimum.addEventListener('input',checkRange);maximum.addEventListener('input',checkRange);intake.addEventListener('submit',checkRange);}}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zd-category-extras"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('zd-tabs')){customElements.define('zd-tabs',class extends HTMLElement{connectedCallback(){const t=[...this.querySelectorAll('[role="tab"]')];const p=t.map(b=>document.getElementById(b.getAttribute('aria-controls')));const sel=i=>{t.forEach((b,j)=>{const on=i===j;b.setAttribute('aria-selected',on);b.tabIndex=on?0:-1;if(p[j]){if(on)p[j].removeAttribute('hidden');else p[j].hidden=true}})};t.forEach((b,i)=>{b.addEventListener('click',()=>sel(i));b.addEventListener('keydown',e=>{let k=e.key==='ArrowRight'?i+1:e.key==='ArrowLeft'?i-1:e.key==='Home'?0:e.key==='End'?t.length-1:null;if(k===null)return;e.preventDefault();k=(k+t.length)%t.length;sel(k);t[k].focus();t[k].scrollIntoView({block:'nearest',inline:'nearest'})})});p.forEach((x,i)=>x&&x.addEventListener('beforematch',()=>sel(i)))}})}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zonlidoog-shop-js"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zonlidoog-shop')) {
  customElements.define('zonlidoog-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.petTabs = [...this.querySelectorAll('[data-pet]')];
      this.petPanels = [...this.querySelectorAll('[data-pet-panel]')];
      this.querySelector('[data-pet-list]').setAttribute('role','tablist');
      this.petTabs.forEach(tab => tab.setAttribute('role','tab'));
      this.petPanels.forEach(panel => {
        panel.setAttribute('role','tabpanel');
        const list = panel.querySelector('[data-category-list]');
        if (list) list.setAttribute('role','tablist');
        panel.querySelectorAll('[data-category]').forEach(tab => tab.setAttribute('role','tab'));
        panel.querySelectorAll('[data-category-panel]').forEach(category => category.setAttribute('role','tabpanel'));
      });
      this.addEventListener('click', event => {
        const pet = event.target.closest('[data-pet]');
        const category = event.target.closest('[data-category]');
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (pet) { event.preventDefault(); this.selectPet(pet.dataset.pet); }
        else if (category) { event.preventDefault(); this.selectCategory(category.closest('[data-pet-panel]'),category.dataset.category); }
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const list = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
        let index = list.indexOf(tab);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = list.length-1;
        else index = (index+(event.key==='ArrowRight'?1:-1)+list.length)%list.length;
        event.preventDefault();
        list[index].click();
        list[index].focus({preventScroll:true});
      }, options);
      this.addEventListener('pointerover', event => {
        const tab = event.target.closest && event.target.closest('[data-category]');
        if (!tab) return;
        const panel = document.getElementById(tab.getAttribute('aria-controls') || '');
        if (panel) this.loadProducts(panel);
      }, options);
      document.addEventListener('click', event => {
        const entry = event.target.closest('[data-zd-pet-entry]');
        if (!entry || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!this.petTabs.some(tab => tab.dataset.pet === entry.dataset.zdPetEntry)) return;
        event.preventDefault();
        this.selectPet(entry.dataset.zdPetEntry);
        this.scrollIntoView({block:'start',behavior:this.motion.matches?'auto':'smooth'});
        this.petTabs.find(tab => tab.dataset.pet === entry.dataset.zdPetEntry).focus({preventScroll:true});
      }, options);
      this.selectPet('perros');
    }
    loadProducts(category) {
      const slot = category.querySelector('[data-products-url]');
      if (!slot || slot.dataset.loading) return;
      slot.dataset.loading = '1';
      slot.setAttribute('aria-busy','true');
      fetch(slot.dataset.productsUrl, {credentials:'same-origin'})
        .then(response => response.ok ? response.text() : Promise.reject(response.status))
        .then(html => { slot.innerHTML = html; slot.removeAttribute('data-products-url'); slot.removeAttribute('aria-busy'); })
        .catch(() => { delete slot.dataset.loading; slot.removeAttribute('aria-busy'); });
    }
    selectPet(key) {
      this.petTabs.forEach(tab => this.setSelected(tab,tab.dataset.pet===key));
      this.petPanels.forEach(panel => {
        panel.hidden = panel.dataset.petPanel !== key;
        if (!panel.hidden) {
          const selected = panel.querySelector('[data-category].is-active') || panel.querySelector('[data-category]');
          if (selected) this.selectCategory(panel,selected.dataset.category);
        }
      });
      this.keepTabVisible(this.petTabs.find(tab => tab.dataset.pet===key));
    }
    selectCategory(panel,key) {
      panel.querySelectorAll('[data-category]').forEach(tab => this.setSelected(tab,tab.dataset.category===key));
      panel.querySelectorAll('[data-category-panel]').forEach(category => {
        category.hidden = category.dataset.categoryPanel !== key;
        if (!category.hidden) this.loadProducts(category);
      });
      this.keepTabVisible(panel.querySelector('[data-category].is-active'));
    }
    setSelected(tab,selected) {
      tab.classList.toggle('is-active',selected);
      tab.setAttribute('aria-selected',String(selected));
      tab.tabIndex = selected?0:-1;
    }
    keepTabVisible(tab) {
      if (!tab) return;
      const holder = tab.closest('[data-category-list]') || tab.closest('[data-pet-list]');
      const box = tab.getBoundingClientRect();
      const parent = holder.getBoundingClientRect();
      if (box.left<parent.left) holder.scrollBy({left:box.left-parent.left-8,behavior:'auto'});
      else if (box.right>parent.right) holder.scrollBy({left:box.right-parent.right+8,behavior:'auto'});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
